import { Share } from "@capacitor/share";
import { isNative } from "./capacitor";

/** Share via the native sheet, the Web Share API, or fall back to the clipboard. Returns how it was shared. */
export async function shareUrl(opts: { title: string; text?: string; url: string }): Promise<"native" | "web" | "clipboard"> {
  if (isNative()) {
    await Share.share({ title: opts.title, text: opts.text, url: opts.url, dialogTitle: opts.title });
    return "native";
  }
  const nav = typeof navigator !== "undefined" ? navigator : undefined;
  if (nav && typeof nav.share === "function") {
    await nav.share({ title: opts.title, text: opts.text, url: opts.url });
    return "web";
  }
  await nav?.clipboard.writeText(opts.url);
  return "clipboard";
}
